import { Platform } from '@ionic/angular';
import { StorageBackend, Requestor } from '@openid/appauth';
import { AuthService, Browser } from 'ionic-appauth-custom';
import { environment } from 'src/environments/environment';
import { NgZone } from '@angular/core';
import {App} from '@capacitor/app';
import {AppLinksService} from '../../../app-links.service';


export let authFactory = (platform: Platform, ngZone: NgZone,
                          requestor: Requestor, browser: Browser,  storage: StorageBackend,
                          appLinksService: AppLinksService) => {

    const authService = new AuthService(browser, storage, requestor);
    authService.authConfig = environment.auth_config;

    if (!platform.is('cordova')) {
        authService.authConfig.redirect_url = window.location.origin + '/auth/callback';
        authService.authConfig.end_session_redirect_url = window.location.origin + '/auth/endsession';
    }

    if (platform.is('capacitor')) {
        console.log('Auth factory registers listener');
        App.addListener('appUrlOpen', (data: any) => {
            if (data.url !== undefined) {
                console.log('Auth factory receives url open event');
                ngZone.run(() => {
                    if ((data.url).indexOf(authService.authConfig.redirect_url) === 0) {
                        authService.authorizationCallback(data.url);
                    }else if ((data.url).indexOf(authService.authConfig.end_session_redirect_url) === 0){
                        authService.endSessionCallback();
                    }

                    // this part shoudln't be here, but I didn't find a way to subscribe to the appUrlOpen event
                    // in another place and get it for sure at app start
                    appLinksService.appLinkCallback(data.url);
                });
            }
        });
    }

    return authService;
};
